import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("aurum_admin_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const getAdminToken = () => localStorage.getItem("aurum_admin_token");
export const setAdminToken = (t) => localStorage.setItem("aurum_admin_token", t);
export const clearAdminToken = () => localStorage.removeItem("aurum_admin_token");
